// src/pages/PINCreate.js
import React, { useState } from "react";
import { setPin } from "../utils/PINService";
import { setPinConfirmedNow, clearPinConfirmed } from "../utils/PINSession";
import { useHistory } from "react-router-dom";
import FormLayout from "../layouts/FormLayout";
import { isZh } from "../utils/language";

const PINCreate = () => {
  const [pin, setLocalPin] = useState("");
  const [pin2, setPin2] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const history = useHistory();

  async function submitHandler(e) {
    e.preventDefault();
    if (!/^\d{6}$/.test(pin)) {
      setMessage({ type: "error", text: isZh() ? "PIN 必須為 6 位數字。" : "PIN harus 6 digit angka." });
      return;
    }
    if (pin !== pin2) {
      setMessage({ type: "error", text: isZh() ? "PIN 確認不一致。" : "Konfirmasi PIN tidak sama." });
      return;
    }

    setLoading(true);
    try {
      const res = await setPin(pin);
      // assume success if res.ok === true or no thrown error
      const ok = !!(res && (res.ok === true || res.message?.toLowerCase()?.includes("disimpan") || res.message?.toLowerCase()?.includes("perbarui")));
      if (ok) {
        clearPinConfirmed();
        //setMessage(history, "PIN berhasil disimpan.", "success");
        setMessage({ 
            type: "success"
            , text: isZh() 
              ? "PIN 已成功設定。請重新輸入 PIN 以繼續。" 
              : "PIN berhasil disimpan. Silakan masukkan ulang PIN untuk melanjutkan." 
          });
        // redirect back or to root
        setTimeout(() => {
          history.replace("/"); 
        }, 1200);
      } else {
        // server returned not-ok
        const msg = (res && res.message) || (isZh() ? "儲存 PIN 失敗。" : "Gagal menyimpan PIN.");
        //setMessage(history, msg, "error");
        setMessage({ type: "error", text: msg });
      }
    } catch (err) {
      // network / server error
      // eslint-disable-next-line no-console
      console.error("setPin error", err);
      //setMessage(history, "Gagal menyimpan PIN. Cek koneksi atau coba lagi.", "error");
      setMessage({ 
        type: "error", 
        text: isZh()
          ? "儲存 PIN 失敗，請檢查網路或稍後再試。"
          : "Gagal menyimpan PIN. Cek koneksi atau coba lagi." 
        });
    } finally {
      setLoading(false);
      setLocalPin("");
      setPin2("");
    }
  }

  // LEFT panel (desktop) - full parent summary/details (example)
  const leftPanelNode = (
    <div></div>
  )

  // LEFT mobile summary (single-line) shown when collapsed on mobile
  const leftSummaryNode = (
    <div style={{ fontWeight: 600 }}>&nbsp;</div>
  );

  // RIGHT panel (desktop) - instructions / petunjuk pengisian
  const rightPanelNode = (
    <div>
      <div style={{ fontWeight: 700, marginBottom: 8 }}>
        {isZh() ? "填寫說明" : "Petunjuk Pengisian"}
      </div>
      <ol>
        <li>{isZh() ? "PIN 用於存取受保護頁面。" : "PIN digunakan untuk akses halaman terbatas."}</li>
        <li>{isZh() ? "必須為 6 位數字。" : "Wajib menggunakan 6 digit angka."}</li>
        <li>{isZh() ? "請勿使用容易猜測的 PIN。" : "Jangan gunakan PIN yang mudah ditebak."}</li>
        <li>{isZh() ? "請妥善記住您的 PIN。" : "Ingat PIN Anda baik-baik."}</li>
      </ol>
    </div>
  );

  const infoNode = message ? (
    <div style={{ padding: 8, borderRadius: 6, background: message.type === "error" ? "#ffecec" : "#e9f6ee", color: message.type === "error" ? "#9b1c1c" : "#064e2d" }}>
      {message.text}
    </div>
  ) : null;

  return (
    <FormLayout  
      title={isZh() ? "建立 PIN" : "Buat PIN Baru"}
      submitLabel={loading ? (isZh() ? "儲存中..." : "Menyimpan...") : (isZh() ? "儲存 PIN" : "Simpan PIN")}
      onSubmit={submitHandler}
      hideTopButton={false}
      leftPanelNode={leftPanelNode}
      leftSummaryNode={leftSummaryNode}
      rightSummaryTitle="Petunjuk"
      rightPanelNode={rightPanelNode}
      infoNode={infoNode}
    >
      {/* fields - pakai style konsisten dengan DaftarUmat */}
      <div style={{ marginBottom: 12 }}>
        <label style={{ display: "block", marginBottom: 6, color: "#2b4a84", fontWeight: 600 }}>
          {isZh() ? "PIN：" : "PIN:"}
        </label>
        <input
          value={pin}
          onChange={(e) => setLocalPin(e.target.value.replace(/\D/g,"").slice(0,6))}
          type="password"
          inputMode="numeric"
          pattern="\d{6}"
          maxLength={6}
          placeholder={isZh() ? "請輸入 PIN（6 位數字）" : "Masukkan PIN (6 digit)"}
          style={{ width: "100%", padding: 10, border: "2px solid #2b4a84", borderRadius: 6 }}
          aria-label="PIN baru"
        />
      </div>

      <div style={{ marginBottom: 12 }}>
        <label style={{ display: "block", marginBottom: 6, color: "#2b4a84", fontWeight: 600 }}>
          {isZh() ? "確認 PIN：" : "Konfirmasi PIN:"}
        </label>
        <input
          value={pin2}
          onChange={(e) => setPin2(e.target.value.replace(/\D/g,"").slice(0,6))}
          type="password"
          inputMode="numeric"
          pattern="\d{6}"
          maxLength={6}
          placeholder={isZh() ? "請再次輸入 PIN（6 位數字）" : "Ulangi PIN (6 digit)"}
          style={{ width: "100%", padding: 10, border: "2px solid #2b4a84", borderRadius: 6 }}
          aria-label="Konfirmasi PIN"
        />
      </div>

      {/* bottom actions — gunakan btn-submit untuk tombol utama */}
      <div style={{ display: "flex", gap: "0.5rem", marginTop: "0.5rem", display:"none" }}>
        <button
          type="submit"
          disabled={loading}
          className="btn-submit"
          style={{ padding: "8px 12px", borderRadius: 8, cursor: loading ? "not-allowed" : "pointer" }}
        >
          {loading ? (isZh() ? "儲存中..." : "Menyimpan...") : (isZh() ? "儲存 PIN" : "Simpan PIN")}
        </button>

        <button
          type="button"
          onClick={() => history.replace("/")}
          style={{ fontSize: "1rem", padding: "8px 12px", borderRadius: 8, background: "#fff", border: "1px solid #e6eaf1", cursor: "pointer" }}
        >
          {isZh() ? "取消" : "Batal"}
        </button>
      </div>

      {/* small spacer */}
      <div style={{ height: 8 }} />
    </FormLayout>
  );
};

export default PINCreate;
